<script setup lang="ts">
import { FirefoxDragAndDrop, SnackbarItem } from '@rfc/rfc-components-library'
import { EStoreGlobalModules } from '@rfc/rfc-components-library/store'
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import ContextProvider from './components/ContextProvider/ContextProvider.vue'
import { ENotificationActions } from './store/notificationStore/NotificationStoreTypes'
import { getCurrentThemeMode } from './utils/viewsUtils'

const route = useRoute()
const store = useStore()

const notificationMessage = computed(
    () => store.state[EStoreGlobalModules.NOTIFICATION]?.message ?? null
)
const notificationType = computed(() => store.state[EStoreGlobalModules.NOTIFICATION]?.type ?? null)

const clearNotification = () => {
    store.dispatch(`${EStoreGlobalModules.NOTIFICATION}/${ENotificationActions.CLEAR}`)
}
</script>

<template>
    <FirefoxDragAndDrop />
    <div class="app-content">
        <v-responsive>
            <v-app :theme="getCurrentThemeMode">
                <ContextProvider>
                    <RouterView :route="route" />
                </ContextProvider>
                <!-- <DrawerProvider /> -->
                <SnackbarItem
                    :message="notificationMessage"
                    :type="notificationType"
                    @close="clearNotification" />
            </v-app>
        </v-responsive>
    </div>
</template>
